import { render } from "./App.vue?vue&type=template&id=734173f6"
const script = {}

import exportComponent from "/home/zhenyan/WebstormProjects/live-data-viewer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__